import axios, { AxiosError } from 'axios';

const POOL_ERROR = 'Sign-in is temporarily unavailable. Please try again.';
const CONVERT_ERROR = 'Account conversion could not be completed. Please sign in again.';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080', timeout: 50000 });

// Replace the axios message the UI renders. Drop the request config so the
// password and legacy bearer token are not attached to the rejected error.
api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        const message = error.config?.url?.includes('/auth/password/convert') ? CONVERT_ERROR : POOL_ERROR;
        return Promise.reject(new AxiosError(message));
    }
);

export type PasswordPool = { user_pool_id: string; client_id: string; convert: boolean };
export type ConvertedSession = { id_token: string; access_token: string; refresh_token: string; username: string };

export function getPasswordPool(email: string): Promise<PasswordPool> {
    return api.post<PasswordPool>('/auth/password/pool', { email }).then((res) => res.data);
}

export function convertPassword(input: { token: string; password: string }): Promise<ConvertedSession> {
    return api
        .post<ConvertedSession>(
            '/auth/password/convert',
            { password: input.password },
            { headers: { Authorization: `Bearer ${input.token}` } }
        )
        .then((res) => res.data);
}
